jQuery(function($) {
    function handleResize() {
        var windowWidth = $(window).width();

        // Unbind first
        $('.menu-list .item.with-sub ul.menu > li.menu-item-has-children > a').off('click.footerMenu');

        if (windowWidth < 992) {
            $('.menu-list .item.with-sub ul.menu > li.menu-item-has-children > a').on('click.footerMenu', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var $itemLi = $(this).closest('li');
                $('.menu-list .item.with-sub ul.menu > li.menu-item-has-children').not($itemLi).removeClass('open');
                $itemLi.toggleClass('open');
                return false;
            });
        }
    }

    handleResize();
    $(window).on('resize', handleResize);
});
